import { Card, Row, Col } from 'reactstrap';
import { transformNumberCurrency } from '@utils';
import { Eye, Activity, Heart } from 'react-feather';

const Stats2Component = ({ data }) => {
  return (
    <Row>
      <Col md={3}>
        <Card
          body
          className="d-flex align-items-center justify-content-center h-100"
        >
          <Col
            md={2}
            style={{
              marginBottom: 10
            }}
          >
            <Eye size={20} color="#47d0e9" />
          </Col>
          <Col md={10}>
            <div
              style={{
                fontWeight: 'bold',
                color: '#6d6b7b',
                fontSize: 20,
                textAlign: 'center',
                marginBottom: 5
              }}
            >
              {transformNumberCurrency(data.totalRoadsConsume / 100, 'percent')}
            </div>
            <div
              className="fst-normal text-center"
              style={{
                fontSize: 12
              }}
            >
              Consumo Camino prom.
            </div>
          </Col>
        </Card>
      </Col>
      <Col md={3}>
        <Card
          body
          className="d-flex align-items-center justify-content-center h-100"
        >
          <Col
            md={2}
            style={{
              textAlign: 'center',
              marginBottom: 10
            }}
          >
            <Activity size={20} color="#ea5556" />
          </Col>
          <Col md={10}>
            <div
              style={{
                fontWeight: 'bold',
                color: '#6d6b7b',
                fontSize: 20,
                textAlign: 'center',
                marginBottom: 5
              }}
            >
              {transformNumberCurrency(data.totalRoadsShare, 'decimal')}
            </div>
            <div
              className="fst-normal text-center"
              style={{
                fontSize: 12
              }}
            >
              Caminos Compartidos
            </div>
          </Col>
        </Card>
      </Col>
      <Col md={3}>
        <Card
          body
          className="d-flex align-items-center justify-content-center h-100"
        >
          <Col
            md={2}
            style={{
              textAlign: 'center',
              marginBottom: 10
            }}
          >
            <Heart size={20} color="#756af0" />
          </Col>
          <Col md={10}>
            <div
              style={{
                fontWeight: 'bold',
                color: '#6d6b7b',
                fontSize: 20,
                textAlign: 'center',
                marginBottom: 5
              }}
            >
              {transformNumberCurrency(data.totalRoadsLikes, 'decimal')}
            </div>
            <div
              className="fst-normal text-center"
              style={{
                fontSize: 12
              }}
            >
              Me Gusta - Caminos
            </div>
          </Col>
        </Card>
      </Col>
    </Row>
  );
};

export default Stats2Component;
